import React from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { FiPlay, FiSquare, FiPause } from 'react-icons/fi';
import { useAudioContext } from '../../context/AudioContext';

export default function AudioPlayerButton({ text, title = '', id = '' }) {
  const { 
    isPlaying, 
    isPaused, 
    currentTextId, 
    playText, 
    togglePlayPause, 
    stopAudio 
  } = useAudioContext();

  // Usar el título como ID si no se provee uno (fallback)
  const uniqueId = id || title;
  const isThisPlaying = currentTextId === uniqueId && isPlaying;

  const handlePlayPause = () => {
    if (isThisPlaying) {
      togglePlayPause();
    } else {
      playText(uniqueId, title, text);
    }
  };

  if (!isThisPlaying) {
    return (
      <Tooltip label="Escuchar" aria-label="Escuchar">
        <IconButton
          icon={<FiPlay />}
          onClick={handlePlayPause}
          variant="ghost"
          colorScheme="brand"
          size="sm"
          aria-label="Escuchar"
        />
      </Tooltip>
    );
  }

  return (
    <>
      <Tooltip label={isPaused ? "Reanudar" : "Pausar"} aria-label={isPaused ? "Reanudar" : "Pausar"}>
        <IconButton
          icon={isPaused ? <FiPlay /> : <FiPause />}
          onClick={handlePlayPause}
          variant="solid"
          colorScheme="brand"
          size="sm"
          mr={1}
          aria-label={isPaused ? "Reanudar" : "Pausar"}
        />
      </Tooltip>
      <Tooltip label="Detener" aria-label="Detener">
        <IconButton
          icon={<FiSquare />}
          onClick={stopAudio}
          variant="outline"
          colorScheme="red"
          size="sm"
          aria-label="Detener"
        />
      </Tooltip>
    </>
  );
}
